module.exports = "/assets/87b7ab2ec963930f02a2db1de99318d1.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos-small/QR.png
// module id = 2884
// module chunks = 0